import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** The shadcn `cn`: clsx for conditionals, tailwind-merge so a caller's class wins over a default. */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs))
}
